import gsap from 'gsap';
import EventDispatcher from '../common/EventDispatcher';
import { Global } from '../common/global';

export default class Instruction {
  constructor() {
    document
      .querySelector('#instruction #playBtn')
      .addEventListener('click', this.onNext.bind(this));
  }
  init() {

    this.playBtnFlag = false;

    this.screenActive = false;
    this.events = EventDispatcher.getObj();
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
  }
  onEvents(data) {
    switch (data['message']['event_type']) {
      case 'show_screen':
        this.showScreen(data['message']['data']);
        break;
    }
  }
  showScreen(data) {
    if (data['screenKey'] !== 'Instruction') return false;

    //Global.scenario
    this.screenActive = true;

    setTimeout(() => {
      document.querySelector('#instruction').classList.add('active');
      this.playBtnFlag = true;
    }, 0);
    setTimeout(() => {
      document.querySelector('#instruction').classList.add('active2');
    }, 10);

    this.rotateIndex = -10;
    this.rotateInt = setInterval(() => {
      document
        .querySelector('#instruction .rotate .icon')
        .classList.remove(`icon${this.rotateIndex}`);

      this.rotateIndex++;
      if (this.rotateIndex > 18) {
        this.rotateIndex = 1;
      }
      document
        .querySelector('#instruction .rotate .icon')
        .classList.add(`icon${this.rotateIndex}`);
    }, 100);

    this.tapIndex = -10;
    this.tapInt = setInterval(() => {
      document
        .querySelector('#instruction .tap .icon')
        .classList.remove(`tap${this.tapIndex}`);

      this.tapIndex++;
      if (this.tapIndex > 10) {
        this.tapIndex = 1;
      }
      document
        .querySelector('#instruction .tap .icon')
        .classList.add(`tap${this.tapIndex}`);
    }, 100);
  }
  animateScreen() { }

  hideScreen() {
    if (!this.screenActive) return;
    this.screenActive = false;
    document.querySelector('#instruction').classList.add('active3');
    setTimeout(() => {
      document.querySelector('#instruction').classList.remove('active3');
      document.querySelector('#instruction').classList.remove('active2');
      document.querySelector('#instruction').classList.remove('active');
    }, 800);
    // document.querySelector('#homeScr').classList.remove('active2');
    // document.querySelector('#homeScr').classList.remove('active2');
  }
  onNext() {

    if (!this.playBtnFlag) return;
    this.playBtnFlag = false;

    Global.serverObj.send(Global.URL_VUPDATE, null, null, {
      saveType: '360playClick',
      uniqID: Global.U_ID,
    });
    this.hideScreen();
    setTimeout(() => {
      // this.events.dispatchEvent({
      //   type: 'GAMESCENE_EVENTS',
      //   message: {
      //     event_type: 'enable_control',
      //     data: {},
      //   },
      // });
      this.events.dispatchEvent({
        type: 'GAME_EVENTS',
        message: {
          event_type: 'start_game',
          data: {},
        },
      });
    }, 1000);
  }
}
